// tutorial: traduzioni delle stringhe della funzione di traduzione $t
// traduzione dei messaggi d'errore di vee-validate
const ru = {
    'countryCode': 'ru_ru',
    'Accetto il regolamento fidelity e la privacy policy': 'Я принимаю правила карты лояльности WE Card и политику конфиденциальности',
    'Account creation': 'Создание учетной записи',
    'Add address': 'Добавить адрес',
    'Address': 'Адрес',
    'Address label': 'Имя адреса',
    'Address label placeholder': 'например, дом, работа...',
    'Agreement': 'консенсус',
    'Amount': 'Сумма',
    'Apply': 'Применить',
    'Apply Discount': 'Применить скидку',
    'Are you sure you want to delete this item from cart': 'Вы уверены, что хотите удалить этот товар из корзины?',
    'Are you sure you want to move this item to wishlist?': 'Вы уверены, что хотите переместить этот товар в список желаний?',
    'articles': 'Товары',
    'articles inside': 'изделия внутри',
    'Back': 'Назад',
    'Back to cart': 'Назад в корзину',
    'Back to shopping': 'Вернуться к покупкам',
    'Back to store': 'Вернуться в магазин',
    'Billing address': 'Платежный адрес',
    'Billing address is the same as the shipping address': 'Платежный адрес совпадает с адресом доставки',
    'Bonus WE card': 'Бонусная карта WE',
    'Buy': 'Купить',
    'Buy Now': 'Купить сейчас',
    'Buy now, pay later': 'Купите сейчас, заплатите позже',
    'Cancel': 'Отменить',
    'Cannot apply Gift Card': 'Не удается применить подарочную карту',
    'Card issuer authentication failed': 'Не удалось проверить подлинность эмитента карты',
    'Cart': 'Корзина',
    'Cart content': 'Содержимое корзины',
    'Change': 'Изменить',
    'Change address': 'Изменить адрес',
    'Change e-mail': 'Изменить адрес электронной почты',
    'Change pickup point': 'Изменить пункт самовывоза',
    'Changing Zip code will redirect to cart to select shipping method again': 'Изменение почтового индекса перенаправит вас в корзину, чтобы снова выбрать способ доставки',
    'Check zip code': 'Проверить почтовый индекс',
    'Choose a shipping method in order to proceed': 'Чтобы продолжить, выберите способ доставки',
    'Choose a store for the pick-up in order to proceed': 'Выберите магазин для получения заказа, чтобы продолжить',
    'Choose a zipcode in order to proceed': 'Выберите почтовый индекс в заказе, чтобы продолжить',
    'City': 'Город',
    'Close': 'Закрыть',
    'Closed': 'Закрыто',
    'Color': 'Цвет',
    'Complete your order': 'Оформить заказ',
    'Condizioni di vendita': 'Условия продажи',
    'Confirm': 'Подтверждение заказа',
    'Continue': 'Продолжить',
    'Continue as guest': 'Продолжить как гость',
    'Country': 'Страна',
    'Coupon': 'Купон',
    'Coupon Code': 'Код скидки',
    'Credit Card': 'Банковская карта',
    'Credit Card Number': 'Номер банковской карты',
    'data': 'Авторизация',
    'Date of birth': 'Дата рождения',
    'Date of Birth': 'Дата рождения',
    'dd/mm/yyyy': 'дд/мм/гггг',
    'Delete': 'Удалить',
    'Delivery:': 'Доставка:',
    'Description': 'Описание',
    'Do you have a discount code?': 'Ваш код скидки?',
    'Enter your Gift Card here': 'Ввести здесь номер подарочной карты',
    'do-login': 'Войдите в систему',
    'done': 'Выполнено',
    'E-mail address': 'Адрес электронной почты',
    'Edit': 'Редактировать',
    'Edit address': 'Изменить адрес',
    'Edit Cart': 'Редактировать корзину',
    'Email': 'Электронная почта',
    'Email and telephone number': 'Электронная почта и номер телефона',
    'email-remainder': 'Мы отправили Вам письмо, чтобы сбросить пароль. Нажмите на ссылку, которая придет на Вашу почту.',
    'Empty credit card fields': 'Пожалуйста, заполните данные банковской карты',
    'Enter shipping address': 'Введите адрес доставки',
    'Enter the points to be used here': 'Enter the points to be used here',
    'Error during payment authorization': 'Ошибка при авторизации платежа',
    'Error during registration': 'Ошибка при регистрации',
    'Error occurred while placing orde': 'Произошла ошибка, при размещении заказа',
    'Expire Date': 'Дата истечения срока действия',
    'Female': 'Женский',
    'Firstname': 'Имя',
    'Forgot your password?': 'Забыли пароль?',
    'Free': 'Бесплатно',
    'freeshippingmsg': '<strong>Добавь {tot}</strong> и        ты <strong>получишь бесплатную</strong> доставку',
    'Friday': 'Пятница',
    'From': 'От',
    'Gender': 'Пол',
    'Gift': 'Поздравительное сообщение',
    'Gift Card': 'Подарочная карта',
    'Gift card and discount codes': 'Подарочный сертификат и коды скидки',
    'giftcardmsg': 'Giftcard {code}',
    'Glam card discount': 'Скидка WE Card',
    'glamcard-bonusapplied': '{bonus} баллов карты WE применено',
    'Go to checkout': 'Перейти к оформлению заказа',
    'Go to payment': 'Продолжить',
    'Go to shipping': 'Перейти к отправке',
    'Go to summary': 'Перейти к сводке',
    'Greeting card': 'Поздравительная открытка',
    'Home delivery cost': 'Стоимость доставки на дом',
    'How many points do you want to use?': 'Сколько бонусов Вы хотите использовать?',
    'How much bonus do you want to use?': 'How much bonus do you want to use?',
    'I authorize the use of my personal data': 'Я предоставляю свое согласие на обработку персональных данных',
    'I don\'t want to receive the invoice': 'Я не хочу получать счет',
    'I want to receive the invoice': 'Я хочу получить счет-фактуру',
    'Identical to shipping address': 'Идентично адресу доставки',
    'Insert here coupon code': 'Вставьте сюда код купона',
    'Insert here the shipping data': 'Вставьте сюда данные о доставке',
    'Insert here your email to proceed, we will send you just the order updates': 'Вставьте сюда свою электронную почту, чтобы продолжить, мы вышлем Вам обновление по статусу заказа',
    'Insert your billing address': 'Укажите свой адрес для выставления счетов',
    'Insert your ZIP code to see shipping methods': 'Введите свой почтовый индекс, чтобы увидеть способы доставки',
    'Inviaci il tuo messaggio e noi scriveremo per te una dedica speciale!': 'Отправьте нам свое сообщение, и мы напишем для Вас специальное поздравление!',
    'invoice': 'Оплата',
    'Invoice address': 'Ваши данные',
    'Last name': 'Фамилия',
    'Lastname': 'Фамилия',
    'Leave': 'Выход',
    'Loading': 'Загрузка',
    'Loading payment form, please wait': 'Форма оплаты загружается, пожалуйста, подождите',
    'login': 'логин',
    'Login': 'Войти',
    'Male': 'Мужской',
    'Message': 'Сообщение',
    'Mobile phone': 'Мобильный телефон',
    'Monday': 'понедельник',
    'Move item': 'Переместить товар',
    'Move product': 'Переместить продукт',
    'Name': 'Имя',
    'New address': 'Новый адрес',
    'New client': 'Новый клиент',
    'No items in cart': 'Корзина пуста',
    'No near stores': 'Нет ближайших магазинов',
    'Not registered yet?': 'Еще не зарегистрирован?',
    'Ok': 'Ok',
    'Or': 'или',
    'Order detail': 'Детали заказа',
    'Order details': 'Детали заказа',
    'Order placed': 'Заказ выполнен. Вы будете перенаправлены на страницу c товаром',
    'Order will be shipped to': 'Заказ будет отправлен в',
    'Password': 'Пароль',
    'Password confirm': 'Подтверждение пароля',
    'Pay': 'Завершить покупку',
    'payment': 'Завершить покупку',
    'Payment': 'Завершить покупку',
    'Payment error.': 'Ошибка оплаты',
    'Payment method': 'Cпособ оплаты',
    'Payment method not supported': 'Средство платежа не поддерживается',
    'Personal data': 'Ваш e-mail',
    'E-mail': 'Ваш e-mail',
    'Pickup point': '',
    'Place of birth': 'Место рождения',
    'Place of Birth': 'Место рождения',
    'Please select shipping from Amazon widget': 'Выберите виджет доставки с Amazon',
    'Please try again with another form of payment': 'Повторите попытку с использованием другого средства платежа',
    'Please wait': 'Пожалуйста подождите',
    'Please wait, payment is processing': 'Пожалуйста, подождите. Платеж обрабатывается',
    'Postcode': 'Индекс',
    'Prefix': 'Префикс',
    'Proceed': 'Продолжить',
    'Proceed delete': 'Продолжить удаление',
    'Proceed to payment': 'Перейти к оплате',
    'Proceed with the purchase': 'Продолжить покупку',
    'product': 'артикул',
    'Product': 'Товар',
    'products': 'aртикулы',
    'Products total': 'Всего продуктов',
    'Qnt.': 'Шт ',
    'Quantity': 'Количество',
    'Register': 'Зарегистрироваться',
    'Registered User': 'Зарегистрированный пользователь',
    'Registration agreement': 'Регистрационное соглашение',
    'Registration successful': 'Регистрация выполнена успешно',
    'registrationagreement': 'Я принимаю <a href="{linkfid}" target="_blank">правила карты лояльности WE Card</a> и <a href="{linkpriv}" target="_blank">политику конфиденциальности</a>',
    'Remove': 'Удалить',
    'Remove Discount': 'Убрать скидку',
    'Remove the item': 'Удалить товар',
    'Required fields': 'Обязательные поля',
    'Retry': 'Повторить попытку',
    'review': 'обзор',
    'Safe purchase': 'Безопасная покупка',
    'Same as billing': 'Совпадает с адресом плательщика',
    'Saturday': 'Суббота',
    'Save': 'Сохранить',
    'Save address': 'Сохранить адрес',
    'Save in address book': 'Сохранить в адресной книге',
    'Save new address to proceed': 'Сохраните новый адрес, чтобы продолжить',
    'Select': 'Выбрать',
    'Select a city': 'Выберите город',
    'Select a payment method': 'Выберите способ оплаты',
    'Select a region': 'Выберите регион',
    'Select an address': 'Укажите адрес',
    'Select here your shipping address': 'Выберите здесь свой адрес доставки',
    'Select payment method': 'Выберите способ оплаты',
    'Select region': 'Выберите регион',
    'Select shipping method': 'Выберите способ доставки',
    'Select store pickup': 'Выберите самовывоз из магазина',
    'Select store pickup to procede': 'Выберите получение в магазине, чтобы продолжить ',
    'Select the store': 'Выберите магазин',
    'Select this store': 'Выберите этот магазин',
    'Select value': 'Выберите значение',
    'Selected Store': 'Выбранный магазин',
    'Seleziona il metodo di spedizione': 'Выберите способ доставки',
    'Send remainder': 'Отправить по электронной почте восстановление пароля',
    'Service unavailable, retry later': 'Временная ошибка при запросе, повторите попытку в ближайшее время',
    'Session expired, page will reload': 'Срок сеанса истек, страница перезагрузится',
    'shipping': 'Способ доставки',
    'Shipping': 'Способ доставки',
    'Shipping address': 'Адрес для выставления счета',
    'Shipping and handling': 'Доставка и управление заказом',
    'Shipping data': 'ДАННЫЕ КЛИЕНТА',
    'Shipping informations': 'Моя информация',
    'Shop opening hours': 'Время работы магазина',
    'Shopping Cart': 'Корзина',
    'shopping details': 'детали покупки',
    'Size': 'Размер',
    'Something went wrong during Yandex Checkout': 'Что-то пошло не так при расчете в Yandex',
    'State/Region': 'Регион',
    'Store selection': 'Выбор магазина',
    'street': 'улица',
    'Street': 'Улица',
    'Street number': 'Дом-Квартира',
    'Sunday': 'Воскресенье',
    'Surname': 'Фамилия',
    'Tax included': 'С учетом НДС',
    'Telephone': 'Телефон',
    'Telephone number': 'Email and telephone number',
    'Telephone number for courier / store pickup': 'Телефон для курьера / самовывоза из магазина',
    'Terranova stores near you': 'Ближайшие магазины Terranova',
    'The coupon code isn\'t valid. Verify the code and try again.': 'Купон недействителен. Проверьте код и попробуйте еще раз.',
    'The gift card is invalid or empty. Please check the gift card and try again': 'Подарочный сертификат недействителен или пуст. Проверьте подарочный сертификат и повторите попытку',
    'The maximum value of the usable We+Card bonus is': 'Максимальное значение бонусов WE Card',
    'The maximum value of the usable WE+Card points is': 'Максимальное количество бонусов WE CARD, которые можете использовать составляет',
    'The order is already been paid, please wait while order is placing': 'Заказ уже оплачен, дождитесь размещения заказа',
    'The password must be made up of at least 8 characters, including a capital letter, a small letter, a number and a special character (.;,!$#).': 'Пароль должен состоять минимум из 8 символов и содержать прописную букву, строчную букву, цифру и специальный символ (.;,!$#).',
    'The requested qty is not available': 'Запрошенное кол-во недоступно',
    'There has been an error. Please try again': 'Произошла ошибка. Повторите попытку',
    'This email already esists. Do the login or proceed as guest': 'Это электронный адрес уже есть. Выполните вход в систему или продолжите как гость',
    'This product is not available, please remove it from cart to proceed': 'Этот продукт недоступен, пожалуйста, удалите его из корзины, чтобы продолжить',
    'Thursday': 'Четверг',
    'To': 'К',
    'Total': 'Итого',
    'Tuesday': 'вторник',
    'Type of card': 'Тип карты',
    'Update address': 'Обновить адрес',
    'Use bonus': 'Использовать бонусы',
    'Use Glam Card Bonus': 'Используйте бонусы WE Card',
    'Use points': 'Использовать бонусы',
    'Use WE+ points': 'Использовать баллы карты WE Card',
    'User': 'Пользователь',
    'Valid until': 'Действителен до',
    'VAT number': 'Номер ИНН',
    'Verify billing address': 'Подтвердить адрес выставления счетов',
    'Verify Gift Card': 'Подтвердить подарочную карту',
    'Verify payment method selection': 'Подтвердите выбор способа платежа',
    'Verify shipping address': 'Подвердить адрес для покупки',
    'Verify shipping method selection': 'Подтвердить выбранный способ доставки',
    'View your cart': 'Посмотреть корзину',
    'Vuoi impreziosire il tuo regalo con un messaggio personalizzato?': 'Хотите украсить свой подарок персонализированным сообщением?',
    'Wait for page to reload': 'Дождитесь перезагрузки страницы',
    'Wednesday': 'среда',
    'You are ordering with this email address': 'Вы делаете заказ по этому адресу электронной почты',
    'You are shipping in a foreign country': 'Вы отправляете в другую страну',
    'Your available points': 'Количество доступных бонусов',
    'Your avalaible bonus': 'Баланс бонусов',
    'Your cap is': 'Ваш индекс',
    'Zip code': 'Индекс',
    'Zip or city': 'Почтовый индекс или город',
    'Shipping cost excluded': 'Стоимость доставки не включена',
    'Extra address': 'Дополнительная информация (по желанию)',
    'Extra address placeholder': 'на адрес, добавочный номер, Округ, Ф.И.О. на домофоне',
    '8 characters': '8 символов',
    '1 lowercase letter': '1 строчная буква',
    '1 uppercase letter': '1 заглавная буква',
    '1 number': '1 цифра',
    '1 special character': '1 специальный символ',
    'Now you can use your points': 'Теперь вы можете использовать свои баллы',
    'Hallo': 'Здравствуйте',
    'Save Credit Card (One Click Payment)': 'Сохранить кредитную карту (оплата в один клик)',
    'Pay with a saved credit card': 'Оплатить с помощью сохраненной кредитной карты',
    'Pay with a new credit or debit card': 'Оплатить новой кредитной или дебетовой картой',
    'Expiration': 'Срок действия',
    'Other': 'Другие',
    'Applied discounts': 'Примененные скидки',
    'Further': 'Далeе',
    'Choose size': 'Выберите размер',
    'Municipality': 'Муниципалитет',
    'To proceed you must select a payment method': 'Чтобы продолжить, необходимо выбрать способ оплаты',
    'To proceed you need to save the selected billing address': 'Чтобы продолжить, необходимо сохранить выбранный адрес для выставления счетов',
    'To proceed it is necessary to accept the general conditions of sale': 'Чтобы продолжить, необходимо принять общие условия продажи',
    'To proceed you need to select the store': 'Чтобы продолжить, необходимо выбрать магазин',
    'To proceed you need to save your changes': 'Чтобы продолжить, необходимо сохранить изменения',
    'Are you sure you want to delete this address?': 'Вы уверены, что хотите удалить этот адрес?',
    'To proceed you need to save the selected shipping address': 'Для продолжения вам необходимо сохранить выбранный адрес доставки',
    'amount-for-freeshipping': 'Вам нужно потратить ещё {amount}, чтобы получить бесплатную доставку',
    'message-double_optin_using_point_disabled': 'Вы не можете использовать баллы для этой покупки, поскольку вы еще не подтвердили действительность своего адреса электронной почты или номера телефона. В случае каких-либо сомнений свяжитесь с нашей службой поддержки клиентов',
}

export default ru;
export const ruValidation = {
    name: "ru",
    messages: {
        _default: function (e: any) {
            return "Значение поля " + e + " недопустимо."
        },
        after: function (e: any, n: any) {
            return "Il " + e + " должно быть после" + n[0] + "."
        },
        alpha: function (e: any) {
            return "Поле " + e + "может содержать только алфавитные символы."
        },
        alpha_dash: function (e: any) {
            return "Поле " + e + " может содержать буквенно-числовые символы, а также линии и подчеркивания."
        },
        alpha_num: function (e: any) {
            return "Поле " + e + "может содержать только буквенно-цифровые символы."
        },
        alpha_spaces: function (e: any) {
            return "Поле " + e + " может содержать только буквенно-цифровые символы, а также пробелы."
        },
        before: function (e: any, n: any) {
            return "Поле " + e + " должно быть до " + n[0] + "."
        },
        between: function (e: any, n: any) {
            return "Поле " + e + " должно быть между " + n[0] + " e " + n[1] + "."
        },
        confirmed: function (e: any, n: any) {
            return "Поле " + e + " не соответствует с " + n[0] + "."
        },
        credit_card: function (e: any) {
            return "Поле " + e + " недопустимо."
        },
        date_between: function (e: any, n: any) {
            return "La " + e + " должна быть между " + n[0] + " e " + n[1] + "."
        },
        date_format: function (e: any, n: any) {
            return "La " + e + " должен быть в формате " + n[0] + "."
        },
        decimal: function (e: any, n: any) {
            void 0 === n && (n = []);
            var r = n[0];
            return void 0 === r && (r = "*"), "Поле " + e + "должен быть числовым и может содержать" + (r && "*" !== r ? " " + r : "") + " десятичные точки."
        },
        digits: function (e: any, n: any) {
            return "Поле " + e + " должен быть числовым и содержать  " + n[0] + " цифр."
        },
        dimensions: function (e: any, n: any) {
            return "Поле " + e + " должно быть " + n[0] + " x " + n[1] + "."
        },
        email: function (e: any) {
            return "Поле " + e + " должен быть действительный адрес электронной почты."
        },
        excluded: function (e: any) {
            return "Поле " + e + " должно иметь допустимое значение."
        },
        ext: function (e: any) {
            return "Поле " + e + "  должен быть действительный файл."
        },
        image: function (e: any) {
            return "Поле " + e + "  должно быть изображение."
        },
        included: function (e: any) {
            return "Поле " + e + " должно иметь допустимое значение."
        },
        ip: function (e: any) {
            return "Поле " + e + "  должен быть действительный IP-адрес."
        },
        length: function (e: any, n: any) {
            return "Длина поля" + e + " должно быть " + n[0] + "."
        },
        max: function (e: any, n: any) {
            return "Поле " + e + " не может быть больше, чем " + n[0] + " букв."
        },
        max_value: function (e: any, n: any) {
            return "Поле " + e + " должно быть меньше или равно " + n[0]
        },
        mimes: function (e: any) {
            return "Поле " + e + "должно иметь допустимый тип файла."
        },
        min: function (e: any, n: any) {
            return "Поле " + e + " должно быть, по крайней мере " + n[0] + " букв."
        },
        min_value: function (e: any, n: any) {
            return "Поле " + e + " должно быть больше или равно " + n[0]
        },
        numeric: function (e: any) {
            return "Поле " + e + " может содержать только числовые символы."
        },
        regex: function (e: any) {
            return "Поле " + e + " не имеет допустимого формата."
        },
        required: function (e: any) {
            //return (e == "Condizioni di vendita") ? "Необходимо подтвердить согласие с условиями и политиками продаж." : "Поле " + e + " требуется."
            let message = '';
            switch (e) {
                case "Condizioni di vendita":
                    message = "Необходимо подтвердить согласие с условиями и политиками продаж."
                    break;
                case "консенсус":
                    message = "Требуется Ваше согласие на обработку персональных данных."
                    break;
                default:
                    message = "Поле " + e + " требуется."
                    break;
            }
            return message;
        },
        size: function (e: any, n: any) {
            return "Поле " + e + " должно быть меньше, чем" + function (e) {
                const n = 1024;
                const r = 0 === (e = Number(e) * n) ? 0 : Math.floor(Math.log(e) / Math.log(n));
                const f = parseFloat((e / Math.pow(n, r)).toFixed(2));
                const v = 1 * f;
                return v.toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][r]
            }(n[0]) + "."
        },
        url: function (e: any) {
            return "Поле " + e + " это недопустимый URL-адрес."
        },
        'validate-piva-cf': function (e: any) {
            return 'Неверный номер НДС / налоговый номер.';
        },
        'validate-regionid': function (e: any) {
            return 'Поле область. требуется.';
        },
        'validate-ascii': function(e: any) {
            return 'This field cannot contains special charachters';
        },
        'validate-streetandnumber': function(e: any, n: any) {
            return 'Поля улицы и номера дома не должны превышать {2} символов';
        },
        'validate-data-consensus': function(e: any) {
          return 'Требуется Ваше согласие на обработку персональных данных.';
        },
        'validate-gender': function(e: any) {
            return 'Поле Пол обязательно для заполнения.';
        },
        'validate-password': function(e: any) {
            return 'Пароль должен состоять минимум из 8 символов и содержать прописную букву, строчную букву, цифру и специальный символ (.;,!$#).';
        },
    },
    attributes: {}
};
